// routing
import Routes from 'routes';
// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import ThemeCustomization from 'themes';

// auth provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
import { AuthProvider } from 'contexts/AuthContext';
import { SnackbarProvider } from 'notistack';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => (
    <ThemeCustomization>
        <Locales>
            <NavigationScroll>
                <SnackbarProvider dense maxSnack={3}>
                    <AuthProvider>
                        <Routes />
                    </AuthProvider>
                </SnackbarProvider>
            </NavigationScroll>
        </Locales>
    </ThemeCustomization>
);

export default App;
